/** Map annotation list reducers and hit-testing (hooks/useMapTools.js). Pure module. */

export function addAnnotation(list, { text, lon, lat }, now = Date.now()) {
  const t = (text || '').trim();
  if (!t) return list;
  return [...list, { id: `ann-${now}-${list.length}`, text: t, lon, lat, time: new Date(now).toISOString() }];
}

/** Empty text deletes (an annotation without text is not useful). Unknown ids are a no-op. */
export function updateAnnotation(list, id, text) {
  const t = (text || '').trim();
  if (!list.some((a) => a.id === id)) return list;
  if (!t) return deleteAnnotation(list, id);
  return list.map((a) => (a.id === id ? { ...a, text: t } : a));
}

export function deleteAnnotation(list, id) {
  return list.some((a) => a.id === id) ? list.filter((a) => a.id !== id) : list;
}

/**
 * Nearest annotation within `radiusPx` of the click. `project([lon, lat])` -> {x, y} pixels;
 * `point` is the click's {x, y}. Returns the annotation or null.
 */
export function findAnnotationAt(list, point, project, radiusPx = 14) {
  if (!point || !project) return null;
  let best = null;
  let bestD = radiusPx;
  for (const a of list) {
    const p = project([a.lon, a.lat]);
    if (!p) continue;
    const d = Math.hypot(p.x - point.x, p.y - point.y);
    if (d <= bestD) { best = a; bestD = d; }
  }
  return best;
}
